// Visit https://api.openweathermap.org & then signup to get our API keys for free   $env:NODE_OPTIONS="--openssl-legacy-provider"
module.exports = {
  key: "cf25b6e341485e160151427cae07c241",
  base: "https://api.openweathermap.org/data/2.5/",
};
